import { render, staticRenderFns } from "./alert.package.vue?vue&type=template&id=bcd8d3a6"
import script from "./alert.package.vue?vue&type=script&lang=js"
export * from "./alert.package.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports